<template>
  <div class="settings-tab">
    <h3>Settings</h3>
    <p>Settings configuration will be available soon.</p>
  </div>
</template>

<script>
export default {
  name: "SettingsTab",
  props: {
    selectedProject: {
      type: [String, Number],
      default: null,
    },
  },
  watch: {
    selectedProject: {
      handler(newProject, oldProject) {
        // Only refetch if project actually changed and we have a valid project
        if (newProject && newProject !== oldProject) {
          // Future: Add data fetching logic here when settings are implemented
          console.log("Settings tab - project changed to:", newProject);
        }
      },
      immediate: false,
    },
  },
};
</script>

<style scoped>
.settings-tab {
  padding: 1rem;
}
</style> 